import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    lesson:null,
}

const lessonSlice = createSlice({
    name: "lessons",
    initialState,
    reducers: {
        setLesson(state, action) {
            state.lesson =  action.payload.lesson;
        }
    }
})

export const lessonActions = lessonSlice.actions;
export default lessonSlice
